import React, {Component, ReactNode, RefObject} from 'react';
import $ from 'jquery';
import I18n from 'app/i18n';
import {configStore, userStore} from 'app/store/global';
import {Store} from 'app/store';
import CollectionInterface from 'app/interfaces/CollectionInterface';
import SelectPicker from 'app/components/reusable/SelectPicker';
import {UNKNOWN_COUNTRY} from 'app/utils/Consts';
import {confirmCountryChoice} from 'app/utils/countryRestrictions';
import {askAboutCountryRestrictions} from 'app/components/auth/CountryRestrictionsDialog';
import {observer} from 'mobx-react';

interface RowCountryCodeProps {
    rowClass: string;
    errorHint: ReactNode;
    cleanError: (field: string) => void;
    country_code: string;
    countryToRemove?: string[];
}

const resolveCountryCode = (countryCode?: string): string => {
    if (!countryCode || countryCode === UNKNOWN_COUNTRY) {
        return '';
    }

    const isAvailable = configStore.REG_FLAGS.some(flag => flag.code === countryCode);

    return isAvailable ? countryCode : '';
};

export const RowCountryCode = observer(
    class RowCountryCode extends Component<RowCountryCodeProps> {
    state = {
        confirmedCountryCode: resolveCountryCode(this.props.country_code),
        countryCode: resolveCountryCode(this.props.country_code)
    };

    field: RefObject<HTMLDivElement> = React.createRef();

    countryCodeInCheck: string | null = null;

    unmounted = false;

    componentWillUnmount(): void {
        this.unmounted = true;
    }

    availableFlags = (): CollectionInterface[] => configStore.REG_FLAGS.map((flag): CollectionInterface => ({
        image: flag.image,
        text: flag.name,
        value: flag.code
    })).filter(flag => !this.props.countryToRemove?.includes(`${flag.value}`));

    handleOnChange = async(e: React.ChangeEvent<HTMLSelectElement>): Promise<void> => {
        const selectedValue = e.target.value;

        if (selectedValue === this.countryCodeInCheck) {
            return;
        }
        this.countryCodeInCheck = selectedValue;
        this.setState({confirmedCountryCode: '', countryCode: selectedValue});
        this.cleanError();

        const flag = configStore.REG_FLAGS.find(item => item.code === selectedValue);
        const confirmed = await confirmCountryChoice(
            selectedValue,
            flag?.restrictions || [],
            restrictions => askAboutCountryRestrictions(selectedValue, restrictions)
        );

        this.countryCodeInCheck = null;
        if (this.unmounted) {
            return;
        }

        if (confirmed) {
            this.setState({confirmedCountryCode: selectedValue});
        } else {
            this.setState({countryCode: ''}, this.openCountryList);
        }
    };

    openCountryList = (): void => {
        $(this.field.current).find('select').trigger('chosen:open');
    };

    cleanError = (): void => {
        this.props.cleanError('country_code');
    };

    render(): ReactNode {
        const {rowClass, errorHint} = this.props;
        const {confirmedCountryCode, countryCode} = this.state;

        return <div className={rowClass}>
            <label className="field-label" htmlFor="field-country">{I18n.t('select_country')}</label>
            <div className="field"
                ref={this.field}
                onClick={this.cleanError}>
                {userStore.unknownCountryCode() || !userStore.fullRegistered()
                    ? <div className="classical-select select-with-images">
                        <SelectPicker
                            onChange={this.handleOnChange}
                            value={countryCode}
                            collection={this.availableFlags()}
                            className="select-country"
                            placeholder={I18n.t('select_a_country')}
                            id="field-country"
                        />
                        <div className="field__select-arrow"/>
                        <input type="hidden" name="country_code" value={confirmedCountryCode}/>
                    </div>
                    : <input className="field__input"
                        name="country_code"
                        defaultValue={Store.userCountry(countryCode)} disabled/>}
            </div>
            {errorHint}
        </div>;
    }
    }
);
